import { render, staticRenderFns } from "./MedDetails.vue?vue&type=template&id=b4594066&scoped=true&"
import script from "./MedDetails.vue?vue&type=script&lang=js&"
export * from "./MedDetails.vue?vue&type=script&lang=js&"
import style0 from "./MedDetails.vue?vue&type=style&index=0&id=b4594066&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4594066",
  null
  
)

export default component.exports